module.exports = __webpack_public_path__ + "img/angle-down-sharp-light.0136c8e1.svg";